import { flashResetOverlay } from "../flashResetOverlay";
import { hapticFeedback } from "../hapticFeedback";
import { ladderFail } from "./ladderFail";

export const resetClimb = () => {
    const levels = document.querySelectorAll('.ladder_level');
    levels.forEach((level, index) => {
        if (index === levels.length - 1) {
            level.classList.add('l_deactive', 'l_current');
            level.classList.remove('l_active');
            return;
        } else {
            level.classList.remove('l_active', 'l_current');
            level.classList.add('l_deactive');
        }
    });

    hapticFeedback();
    flashResetOverlay();
    ladderFail();
}